import { defineComponent as i, computed as e, openBlock as s, createBlock as l, unref as c, normalizeClass as o } from "vue";
import { RevAvatar as m } from "@ds/components/Avatar";
import u from "../../../icons/generated/IconBackMarketAvatar.vue2.js";
import f from "../../../icons/generated/IconShop.vue2.js";
const g = /* @__PURE__ */ i({
  __name: "MessageAvatar",
  props: {
    variant: {},
    label: {}
  },
  setup(r) {
    const a = r, t = e(() => a.variant === "customer" ? "bg-static-brand-mid" : a.variant === "seller" ? "bg-static-success-hi" : "bg-static-brand-hi"), n = e(() => {
      if (a.variant === "backmarket") return u;
      if (a.variant === "seller") return f;
    });
    return (b, p) => (s(), l(c(m), {
      class: o(t.value),
      label: r.label,
      size: "medium",
      thumbnail: n.value
    }, null, 8, ["class", "label", "thumbnail"]));
  }
});
export {
  g as default
};
